import { css } from "@emotion/css";

export const triggerCSS = css`
    position: relative;
    display: inline-flex;
`;

export const fakeButtonCSS = css`
    pointer-events: all;
    cursor: not-allowed;

    position: absolute;
    z-index: 1;
    inset: 0;
`;
